import { Button, Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import PageHeader from 'broker/components/common/layout/PageHeader';

export interface CarriersHeaderProps {
  count: number;
  filteredCount: number;
  isFilterApplied: boolean;
  onCreateCarrier: () => void;
}

export default function CarriersHeader({
  count,
  filteredCount,
  isFilterApplied,
  onCreateCarrier,
}: CarriersHeaderProps) {
  return (
    <PageHeader>
      <Stack direction="row" alignItems="baseline" gap={1}>
        <Typography variant="h4">{messages.carriersPage.header.title}</Typography>
        <Typography color="text.secondary" variant="body2">
          {isFilterApplied ? messages.general.outOfCarriers(filteredCount.toString(), count.toString()) : count}
        </Typography>
      </Stack>
      <Button variant="contained" onClick={onCreateCarrier}>
        {messages.carriersPage.createCarrier}
      </Button>
    </PageHeader>
  );
}
